<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando dados...</p></div>
    <MensagemAlerta class="row-space" v-if="msg" :mensagem="msg" />

    <div class="form-edit-page">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">{{ objEdicao.id }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Nome/Descrição</label>
                <input type="text" v-model="objEdicao.nmproduto" maxlength="200" v-uppercase />
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item" style="position:relative">
                <label class="label-caption">Categoria</label>
                <input type="text" v-model="objEdicao.nmcategoria" maxlength="100" v-uppercase
                    @input="categoriasFiltrarSugestoes"
                    @focus="categoriasMostrarTodas"
                    @blur="esconderSugestoes" />

                <ul v-if="lsCategoriasFiltradas.length" class="sugestoes">
                    <li v-for="(item, index) in lsCategoriasFiltradas" :key="index"
                        @mousedown.prevent="categoriasSelecionarSugestao(item.nmcategoria)"
                    >
                        {{ item.nmcategoria }}
                    </li>
                </ul>
            </div>
            
            <div class="form-item-char20">
                <label class="label-caption">Unidade</label>
                <input type="text" v-model="objEdicao.unidade" maxlength="10" v-uppercase />
            </div>

            <div class="form-item-char20">
                <TpProdutoMapaSelect class="form-item" v-model:opcaoSelecionada="objEdicao.tpproduto" />
            </div>
        </div>


        <div class="row-end">
            <label for="ckAtivo">Ativo</label>
            <input type="checkbox" class="input-checkbox" id="ckAtivo" v-model="ckAtivo" />
        </div>

        <div class="row-end">
            <label for="ckResiduo">Resíduo</label>
            <input type="checkbox" class="input-checkbox" id="ckResiduo" v-model="ckResiduo" />
        </div>


        <div class="row-end">
            <button type="button" class="btn-confirm" @click="salvarDados">Salvar</button>
            <button type="button" class="btn-cancel" @click="cancelForm">Cancelar</button>
        </div>   
    </div>
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarProdutoMapa } from '@/models/produtoMapa';
import { globalStore } from '@/globals';
import MensagemAlerta from '@/components/utils/MensagemAlerta.vue';
import TpProdutoMapaSelect from '@/selects/estaticos/TpProdutoMapaSelect.vue';

const emit = defineEmits(['close', 'save']);
const props = defineProps({
    idEdicao: {type: Number, default: 0}
});


const ckAtivo = ref(false);
const ckResiduo = ref(false);
const isLoading = ref(false);
const lsCategorias = ref([]);
const lsCategoriasFiltradas = ref([]);
const msg = ref(null);
const objEdicao = ref(criarProdutoMapa());


const cancelForm = () => {emit('close');}


function categoriasFiltrarSugestoes() {
    const termo = objEdicao.value.nmcategoria.toUpperCase();
    if (termo === "") {
        lsCategoriasFiltradas.value = lsCategorias.value;
    } else {
        lsCategoriasFiltradas.value = lsCategorias.value.filter(c => c.nmcategoria.includes(termo));
    }
}


function categoriasMostrarTodas() {
    lsCategoriasFiltradas.value = lsCategorias.value;
}


function categoriasSelecionarSugestao(valor) {
    objEdicao.value.nmcategoria = valor;
    lsCategoriasFiltradas.value = [];
}


function esconderSugestoes() {
    requestAnimationFrame(() => (lsCategoriasFiltradas.value = []));
}


async function lerDados() {
    try{
        isLoading.value = true;
        msg.value       = null;
        if (props.idEdicao > 0) {
            try{
                const req = await Api.getCadastroById('produto_mapa', props.idEdicao);
                Object.assign(objEdicao.value, req[0]);
            }catch (error){msg.value = error}
        }else{
            objEdicao.value.idep            = globalStore.idep;
            objEdicao.value.idlogin         = globalStore.idlogin;
            objEdicao.value.ckcadastrado    = 'S';
        }
        objEdicao.value.idusuario           = globalStore.idusuario;
        ckAtivo.value                       = objEdicao.value.ativo === 'S';        
        ckResiduo.value                     = objEdicao.value.ckresiduo === 'S';     
        
        // BAIXAR LISTA DE CATEGORIAS
        const ls = await Api.genericPost('/listas/produtos/mapa/categorias', {idep: globalStore.idep});
        lsCategorias.value = ls;


    } catch (error) {msg.value = error;
    }finally{isLoading.value=false;}
}


async function salvarDados() {
    if (!objEdicao.value.nmproduto || objEdicao.value.nmproduto.trim() === '') {msg.value='Informe o nome do produto'; return;}
    if (!objEdicao.value.nmcategoria || objEdicao.value.nmcategoria.trim() === '') {msg.value='Informe o nome do produto'; return;}
    try {
        isLoading.value             = true;
        msg.value                   = null;
        objEdicao.value.ativo       = ckAtivo.value ? 'S' : 'N';
        objEdicao.value.ckresiduo   = ckResiduo.value ? 'S' : 'N';
        const response              = await Api.genericPut('/cad/produto/mapa', objEdicao.value);
        if (response.bolok === 1){
            emit('save');
            emit('close');
        }else{
            msg.value = response.erro;
        }
    } catch (error) {msg.value = error;
    } finally{isLoading.value=false;}
}


onMounted(lerDados);
</script>


<style scoped>
.sugestoes {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    border: 1px solid #ccc;
    background: #fff;
    max-height: 200px;
    overflow-y: auto;
    margin: 0;
    padding: 0;
    list-style: none;
    z-index: 999;
}
.sugestoes li {
    padding: 8px;
    cursor: pointer;
    text-align: left;
}
.sugestoes li:hover {
    background: #eee;
}
</style>